//ecd:-1308371093H20261022084009_V3.0
import { request, requestOrNull, seg, Page } from './apiSupport';
import { CountryDTO } from './CountryDTO';
import { CountryKeyDTO } from './CountryKeyDTO';
import { CountrySrchDTO } from './CountrySrchDTO';

/**
 * REST client for Country.
 *
 * Calls the endpoints CountryController exposes. Generated from the same model the
 * server is, so a change to the DSL shows up here as a type error rather than
 * at runtime.
 *
 * Generated by ElastiCORE. Do not edit outside the ElastiCORE guidelines.
 */
const BASE = '/api/petstore/country';

/** Registers a new Country. */
export async function create(input: CountryDTO): Promise<CountryDTO> {
    return request<CountryDTO>('POST', BASE, input);
}

/** The Country with this identifier, or null when there is none. */
export async function findById(isoCode: string): Promise<CountryDTO | null> {
    return requestOrNull<CountryDTO>('GET', BASE + '/' + seg(isoCode));
}

/** Every Country matching the condition. */
export async function search(condition: CountrySrchDTO): Promise<Page<CountryDTO>> {
    return request<Page<CountryDTO>>('POST', BASE + '/search', condition);
}

/** Updates an existing Country. */
export async function update(input: CountryDTO): Promise<CountryDTO> {
    return request<CountryDTO>('PUT', BASE, input);
}

/** Updates several in one transaction; none are applied if any fails. */
export async function batchUpdate(inputs: CountryDTO[]): Promise<void> {
    return request<void>('PUT', BASE + '/batch', inputs);
}

/** Deletes each key, answering for each whether it was there. */
export async function deleteMany(keys: CountryKeyDTO[]): Promise<boolean[]> {
    return request<boolean[]>('POST', BASE + '/delete', keys);
}

/** Deletes the Country with this identifier. */
export async function deleteById(isoCode: string): Promise<boolean> {
    return request<boolean>('DELETE', BASE + '/' + seg(isoCode));
}

